import { render, staticRenderFns } from "./ContratosEmpleadoComponent.vue?vue&type=template&id=2319c678&"
import script from "./ContratosEmpleadoComponent.vue?vue&type=script&lang=js&"
export * from "./ContratosEmpleadoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports